import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { alertaLoaderHTML, refresh } from 'shared-tsi';
import { catchError, map, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'core-tsi';

export const IGNORE_401 = new HttpContextToken<boolean>(() => false);
export const USE_BEARER = new HttpContextToken<boolean>(() => false);

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  let session = StorageService.getSession();
  const token = session && session.token && session.token.length > 5 ? session.token : '';
  const headers = new HttpHeaders({
    'Authorization': req.context.get(USE_BEARER) && token ? `Bearer ${token}` : token
  })
  const reqClone = req.clone({
    headers
  });

  return next(reqClone).pipe(
    catchError((err: HttpErrorResponse) => {
      const _error = err.error;
      const isBlob = _error instanceof Blob

      const funcionCerrar = () => {
        StorageService.clearStorage();
        refresh()
        router.navigateByUrl(`/login`);
      }

      let html = `<div><img src="../../../../assets/images/logo-tsi-tres.png" class="img-login" ></div>
          <div style="font-size: 1.1rem; font-weight: bolder">
          Ha superado el tiempo límite de inactividad, vuelva a iniciar sesión<div> `;

      const cerrarSesion = () => {
        if (req.context.get(IGNORE_401)) {
          const usersesion = localStorage.getItem('usersesion');
          StorageService.clearStorage();
          localStorage.removeItem('usersesion');
          refresh()
          router.navigateByUrl(`/login/${usersesion}`);
          return;
        }
        alertaLoaderHTML(html, 3000, funcionCerrar)
      }

      if (isBlob && err.status == 401) {
        cerrarSesion()
        return throwError(() => err);
      }

      if (err.status == 401 && _error.message) {
        if (_error.status == 0.9) {
          cerrarSesion()
          return throwError(() => err);
        }

        const _token = _error.message.split("=>")[1]?.trim();

        if (!_token) {
          return throwError(() => err);
        }

        session = StorageService.getSession();
        if (session) {
          session.correo = 'ftarco',
            session.token = _token;
          StorageService.setAll(session);
        }

        const headers = new HttpHeaders({
          'Authorization': req.context.get(USE_BEARER) && session.token ? `Bearer ${session.token}` : session.token || ''
        })
        const reqClone = req.clone({
          headers
        });
        return next(reqClone)

      }
      return throwError(() => err)
    }),
    map((event: HttpEvent<any>) => {
      return event;
    })
  );
};
